import {Autocomplete, Button, Card, Checkbox, Col, Collapse, CollapseItem, Container, DatePicker, Input, Option, Popover, Row, Select, Table, TableColumn, Tooltip} from 'element-ui'
import {Button as PButton, Radio as PRadio, Checkbox as PCheckbox, Pagination as PPagination, Switch as PSwitch, FgInput, Dropdown} from 'src/components/UIComponents'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component(Autocomplete.name, Autocomplete)
    Vue.component(Button.name, Button)
    Vue.component(Card.name, Card)
    Vue.component(Checkbox.name, Checkbox)
    Vue.component(Col.name, Col)
    Vue.component(Collapse.name, Collapse)
    Vue.component(CollapseItem.name, CollapseItem)
    Vue.component(Container.name, Container)
    Vue.component(DatePicker.name, DatePicker)
    Vue.component(Dropdown.name, Dropdown)
    Vue.component(Input.name, Input)
    Vue.component(FgInput.name, FgInput)
    Vue.component(Option.name, Option)
    Vue.component(PButton.name, PButton)
    Vue.component(PCheckbox.name, PCheckbox)
    Vue.component(Popover.name, Popover)
    Vue.component(PPagination.name, PPagination)
    Vue.component(PSwitch.name, PSwitch)
    Vue.component(PRadio.name, PRadio)
    Vue.component(Row.name, Row)
    Vue.component(Select.name, Select)
    Vue.component(Table.name, Table)
    Vue.component(TableColumn.name, TableColumn)
    Vue.component(Tooltip.name, Tooltip)
  }
}

export default GlobalComponents
